import * as React from 'react';
import { DOCUMENT_DATA_DPI, LOW_DPI_THRESHOLD } from "../../_config/Consts";
import { Trans } from 'react-i18next';
import { Popover } from '@mui/material';

export type Props = {
	moduleId: string
	sourceWidth: number,
	sourceHeight: number,
	sourceRatio: number,
	width?: number,
	height?: number,
}

type State = {
	whatsDpiEl?: HTMLElement
}

const T = ({children, ...otherProps}:any) => <Trans ns="create" {...otherProps}>{children}</Trans>

export default class ModuleImageSettings extends React.Component<Props, State> {
	state:State = {}

	private stopPropagation = (e:React.MouseEvent) => e.stopPropagation();

	render = () => {
		let dpi:number = Math.round(Math.min(this.props.sourceWidth / this.props.width, this.props.sourceHeight / this.props.height) * DOCUMENT_DATA_DPI);
		return <div className="dpi-indicator">
			<div className={"status "+(dpi >= DOCUMENT_DATA_DPI ? "good" : dpi >= LOW_DPI_THRESHOLD ? "low" : "verylow")}>
				<T>Quality: </T>
				<span className="value">{dpi}</span> 
				DPI
				<Popover
					className="custom-popover"
					sx={{
					pointerEvents: 'none',
					}}
					open={Boolean(this.state.whatsDpiEl)}
					anchorEl={this.state.whatsDpiEl}
					anchorOrigin={{
						vertical: 'bottom',
						horizontal: 'left',
					}}
					transformOrigin={{
						vertical: 'top',
						horizontal: 'left',
					}}
					onClose={() => this.setState({whatsDpiEl: undefined})}
					disableRestoreFocus
				>
					<h4>Image Resolution</h4>
					<p>If the quality indicator is not green, your print may look blurry or pixelated. You should either make your image smaller, or upload a higher resolution image.</p>
				</Popover>
				<span className="whatsDPI" onMouseDown={this.stopPropagation} onMouseEnter={(e) => this.setState({whatsDpiEl: e.currentTarget})} onMouseLeave={() => this.setState({whatsDpiEl: undefined})}>
					<i className="material-icons">help_outline</i>
				</span>
			</div>
		</div>
	}
}